<template>
  <svg
    width="16"
    height="14"
    viewBox="0 0 16 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.9593 3.94325C14.5685 3.50975 15.0811 2.97079 15.5 2.34689C14.9405 2.59 14.3489 2.75403 13.7279 2.83312C14.3664 2.45233 14.8527 1.8548 15.0811 1.13423C14.4865 1.48866 13.8304 1.73763 13.1303 1.87823C12.568 1.27776 11.7624 0.905762 10.8866 0.905762C9.18483 0.905762 7.814 2.2883 7.814 3.98133C7.814 4.22445 7.83451 4.45878 7.8843 4.68139C5.32718 4.55544 3.06591 3.33107 1.54569 1.46522C1.28207 1.92509 1.1239 2.45233 1.1239 3.02058C1.1239 4.08678 1.67165 5.02996 2.48887 5.57477C1.99385 5.56598 1.51054 5.42246 1.10047 5.19692V5.23207C1.10047 6.72591 2.16667 7.96786 3.56385 8.25198C3.31195 8.31935 3.03954 8.3545 2.75835 8.3545C2.5621 8.3545 2.36292 8.34279 2.17545 8.30178C2.57381 9.52029 3.70445 10.4137 5.04892 10.443C4.00322 11.2602 2.6734 11.7552 1.23521 11.7552C0.983304 11.7552 0.740187 11.7435 0.5 11.7142C1.86204 12.5929 3.47598 13.0938 5.21588 13.0938C10.6465 13.0909 14.1819 8.5654 13.9593 3.94325Z"
      fill="white"
    />
  </svg>
</template>
  
<script>
export default {
  name: "TwitterWhiteIcon",
};
</script>